<mat-drawer-container class="w-full h-full min-h-screen">
    <mat-drawer class="sm:w-96 dark:bg-gray-900 fixed" [autoFocus]="false"
        [mode]="drawerMode" [opened]="drawerOpened" position="end"
        #innerDrawerInfoWindow>
        <div class="flex items-center justify-between m-4 mr-6 sm:my-4">
            <div class="text-4xl font-extrabold tracking-tight leading-none flex flex-row items-center">
                {{title}}
            </div>
            <div>
                <button mat-icon-button (click)="closeSideDrawer()">
                    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </div>
        <div class="flex flex-col divide-y border-t border-b">
            <div class=" m-4 mr-6 sm:my-4">
                <div [innerHTML]="text"></div>
            </div>
        </div>
    </mat-drawer>
    <mat-drawer-content class="min-h-screen h-full">
        <router-outlet class="min-h-screen h-full"></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>
